export default __webpack_public_path__ + "static/media/prologue-realdoor.57403029.png";